import jwtDecode from 'jwt-decode';
import { ControllerParams } from '@wix/yoshi-flow-editor';
import { GiftCardCheckoutService } from '../../../services/GiftCardCheckoutService';
import { GiftCardService } from '../../../services/GiftCardService';
import { CartService } from '../../../services/CartService';

export type AppServices = {
  controllerParams: ControllerParams;
  giftCardCheckoutService: GiftCardCheckoutService;
  giftCardService: GiftCardService;
  cartService: CartService;
};

export const initializeServices = async (
  controllerParams: ControllerParams,
): Promise<AppServices> => {
  const cartService = new CartService(controllerParams);
  const giftCardCheckoutService = new GiftCardCheckoutService(controllerParams);
  const giftCardService = new GiftCardService(controllerParams, {
    withErrorHandler: controllerParams.flowAPI.errorHandler.withErrorHandler,
    getResolvedError: controllerParams.flowAPI.errorHandler.getResolvedError,
  });

  const { metaSiteId } = jwtDecode(
    controllerParams.controllerConfig.appParams.instance,
  ) as {
    metaSiteId: String;
  };

  controllerParams.flowAPI?.bi?.updateDefaults({
    appDefId: controllerParams.controllerConfig.appParams.appDefinitionId,
    instanceId: controllerParams.controllerConfig.appParams.instanceId,
    msid: metaSiteId,
  });

  return {
    controllerParams,
    giftCardCheckoutService,
    giftCardService,
    cartService,
  };
};
